var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconStarFillComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-star-fill").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M7.58954 1.64019C7.74134 1.27521 8.25837 1.27521 8.41017 1.64019L10.0114 5.48997C10.0754 5.64383 10.2201 5.74896 10.3862 5.76228L14.5424 6.09548C14.9364 6.12707 15.0961 6.61879 14.7959 6.87594L11.6294 9.58844C11.5028 9.69685 11.4476 9.86695 11.4862 10.029L12.4537 14.0848C12.5454 14.4693 12.1271 14.7732 11.7898 14.5671L8.2315 12.3937C8.08928 12.3069 7.91043 12.3069 7.76822 12.3937L4.20996 14.5671C3.87262 14.7732 3.45434 14.4693 3.54606 14.0848L4.51349 10.029C4.55216 9.86695 4.49689 9.69685 4.37033 9.58844L1.20377 6.87594C0.903568 6.61879 1.06334 6.12707 1.45736 6.09548L5.61352 5.76228C5.77963 5.74896 5.92433 5.64383 5.98833 5.48997L7.58954 1.64019Z", fillOpacity: "1" }));
}
var IconStarFill = React.forwardRef(IconStarFillComponent);
export default IconStarFill;
